<template>
  <v-dialog
    v-model="showModal"
    persistent
    width="1080px"
    content-class="overflow-visible"
  >
    <v-card class="grey lighten-2">
      <v-toolbar flat dense>
        <v-toolbar-title> Attendance Slip - {{ form ? form.id : '' }}</v-toolbar-title>

        <v-chip
          x-small
          color="blue white--text ml-2"
          class="english text-uppercase"
          dark
          v-if="form.status"
        >
          {{ form.status }}
        </v-chip>

        <v-spacer></v-spacer>

        <v-icon v-if="form.id" class="mx-2" @click="getItem">refresh</v-icon>
        <v-btn icon @click="close()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <!-- <v-btn  @click="sendSms(form_data.id)" x-small >
                                send sms &nbsp;
                                <v-icon x-small color="green" left class="ti ti-help-alt"></v-icon></v-btn> -->
      </v-toolbar>

      <v-row dense class="mt-2 px-2">
        <v-col cols="12" :md="form.id ? 7 : 12">
          <!-- <v-card class="grey lighten-2"> -->
          <!-- {{form}}, {{dateIsPassed}} -->

          <v-card-text
            class="mt-4"
            style="max-height: 80vh; overflow-y: scroll"
            v-if="dataLoaded && form.from_date"
          >
            <v-form v-model="formValid" ref="form" v-if="isEditable && isEditable">
              <v-row class="mt-2 d-flex flex-row pb-3">
                <!-- MANUAL SELECTION ONLY IF NO LOGS -->
                <v-col cols="12" md="6" class="" v-if="logs && logs.length < 1">
                  <span class="input-label">seleced date: </span>

                  <date-picker
                    v-model="form.from_date"
                    type="time"
                    placeholder="Start Time"
                    value-type="YYYY-MM-DD HH:mm"
                    format="DD-MM-YYYY HH:mm"
                    :show-time-panel="showTimePanel"
                    :disabled="!manualRequest"
                    @input="getAttendance"
                  >
                    <template v-slot:footer>
                      <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                        {{ showTimePanel ? 'Select Date' : 'Select Time' }}
                      </button>
                    </template>
                  </date-picker>
                  
                  <v-icon color="green" v-tooltip="'add day'" class="ml-1" @click="addDay" v-if="allowIncrement" >
                      mdi-plus
                  </v-icon>
                </v-col>

                <v-col cols="12" md="6" v-if="logs && logs.length < 1">
                  <v-checkbox
                    @click="clearData"
                    :disabled="!isEditable"
                    v-model="manualRequest"
                    class="mt-0"
                    hide-details
                    :label="
                      'manually select time (card log does not exist)' +
                      (manualRequest ? '' : '')
                    "
                  ></v-checkbox>
                </v-col>
                <!-- MANUAL SELECTION ONLY IF NO LOGS -->

                <!-- SELECT FROM CARD LOG IS HAS LOGS -->
                <v-col cols="12" md="6" v-if="logs && logs.length > 0">
                  <NewSelectEng
                    :options="Object.values(logs)"
                    v-model="form.requested_date"
                    :label="'select a time and date'"
                    :optionKey="'punch_time'"
                    optionLabel="item.punch_time +' - <bdi>'+item.door_name.replaceAll(/[_-]/g, ' ')+'</bdi>'"
                    single-line
                    @input="setSelection()"
                    :disabled="manualRequest"
                    type="html"
                  ></NewSelectEng>
                </v-col>
                <!-- SELECT FROM CARD LOG IS HAS LOGS -->

                <!-- :disabled-date="disabledStartDate"    optionLabel="punch_time"-->
                <v-col cols="12" md="6">
                  <NewSelectEng
                    :options="Object.values(slip_types)"
                    v-model="form.requested_type"
                    :label="'select type'"
                    class="english"
                    :optionKey="'type'"
                    optionLabel="label"
                    single-line
                    @input="setSelection()"
                  ></NewSelectEng>
                </v-col>

                <v-col cols="12" md="6">
                  <NewSelectEng
                    url="/api/finger_machines"
                    v-model="form.machine_id"
                    :label="'Machine'"
                    class="english"
                    :optionKey="'machine_id'"
                    optionLabel="location_label"
                    single-line
                    @input="setSelection()"
                  ></NewSelectEng>
                </v-col>

                <v-col cols="12" class="pl-1">
                  <div class="grey mt-3 px-1">Reason</div>
                  <tiptap-editor
                    :value="form.reason"
                    outlined
                    v-model="form.reason"
                    style="text-align: left !important; direction: ltr !important"
                  ></tiptap-editor>
                </v-col>
              </v-row>
            </v-form>

            <!-- display details -->
            <v-row no-gutters v-if="!isEditable">
              <v-col cols="12">
                <v-card class="pb-2 pa-1" outlined tile>
                  <span class="font-weight-bold"> Request Date & Time: </span>
                  <span
                    ><v-icon
                      small
                      v-tooltip="
                        form.is_manual
                          ? 'staff manually selected time'
                          : 'from user card log'
                      "
                    >
                      {{
                        form.is_manual ? 'mdi-clock-edit-outline' : 'mdi-clock-outline'
                      }}
                    </v-icon></span
                  >
                  <span class="pl-3 english">
                    {{
                      new Date(form.requested_date).toLocaleDateString('en-GB', {
                        hour: '2-digit',
                        minute: '2-digit',
                      })
                    }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card class="pb-2 pa-1" outlined tile>
                  <span class="font-weight-bold"> Request Type: </span>
                  <span class="pl-3 english">
                    {{ form.requested_type }}
                  </span>
                </v-card>
              </v-col>

              <v-col cols="12">
                <v-card class="pa-1" outlined tile>
                  <span class="font-weight-bold pl-2"> Reason: </span>
                  <p
                    v-html="form.reason"
                    class="english"
                    style="text-align: justify; white-space: pre-line"
                  ></p>
                </v-card>
              </v-col>
            </v-row>

            <!-- REASON -->
            <v-row v-if="!['draft', 'pending_approval'].includes(form.status)">
              <v-col cols="12" v-if="form.rejected_reason">
                <v-card class="pa-1" outlined tile>
                  <span class="font-weight-bold pl-2">Rejected Reason: </span>
                  <p
                    v-html="form.rejected_reason"
                    class="english"
                    style="text-align: justify; white-space: pre-line"
                  ></p>
                </v-card>
              </v-col>

              <v-col cols="12" v-if="form.approved_reason">
                <v-card class="pa-1" outlined tile>
                  <span class="font-weight-bold pl-2">Approved Reason: </span>
                  <p
                    v-html="form.approved_reason"
                    class="english"
                    style="text-align: justify; white-space: pre-line"
                  ></p>
                </v-card>
              </v-col>
            </v-row>
            <!-- REASON -->

            <!-- end -->
          </v-card-text>

          <!-- REASON MODAL -->
          <custom-modal
            :title="reasonType == 'reject' ? 'Rejecting Slip' : 'Approving Slip'"
            v-model="reasonModal"
            @close="closeReject()"
            :loading="loading"
            :width="500"
          >
            <v-col cols="12" v-if="reasonType == 'reject'">
              <p class="grey--text mb-2">Rejecting Reson</p>
              <!-- <tiptap-editor
                  :value="form.rejected_reason"
                  outlined
                  v-model="form.rejected_reason"
                  style="text-align: left !important; direction: ltr !important"
                ></tiptap-editor> -->
              <v-textarea dense outlined v-model="form.rejected_reason"></v-textarea>
            </v-col>
            <v-col cols="12" v-if="reasonType == 'approve'">
              <p class="grey--text mb-2">
                Approval Reason (staff manually selected time)
              </p>
              <!-- <tiptap-editor
                  :value="form.approved_reason"
                  outlined
                  v-model="form.approved_reason"
                  style="text-align: left !important; direction: ltr !important"
                ></tiptap-editor> -->
              <v-textarea dense outlined v-model="form.approved_reason"></v-textarea>
            </v-col>
            <template #actions>
              <v-btn
                small
                outlined
                color="success"
                @click="update(reasonType)"
                class="mx-1"
                v-if="
                  form.id &&
                  form.status == 'pending_approval' &&
                  (form.rejected_reason || form.approved_reason) &&
                  $can('hrms')
                "
              >
                save</v-btn
              >
            </template>
          </custom-modal>
          <!-- REASON MODAL -->
          <!-- </v-card> -->
        </v-col>

        <v-col cols="12" md="5" v-if="form.id">
          <ApprovalStages
            class="dhivehi"
            dir="rtl"
            model="AttendanceSlip"
            :refID="form.id"
          ></ApprovalStages>
          <activity-log dir="ltr" model="AttendanceSlip" :ref_id="form.id"></activity-log>
        </v-col>
      </v-row>

      <v-card-actions
        v-if="dataLoaded && form.from_date"
        class="mt-5 mx-0 px-1 d-flex justify-end white"
      >
        <v-btn
          small
          outlined
          color="success"
          @click="save()"
          :disabled="!isFilled"
          class="mx-1"
          v-if="!form.id && !dateIsPassed"
        >
          save draft</v-btn
        >
        <v-btn
          small
          outlined
          color="success"
          @click="submit()"
          :disabled="!isFilled"
          class="mx-1"
          v-if="form.id && form.status == 'draft'"
          >submit</v-btn
        >
        <v-btn
          class="mx-1"
          small
          outlined
          color="blue"
          @click="update(actionType)"
          :disabled="!isFilled"
          v-if="form.id && isEditable"
        >
          update
        </v-btn>

        <!-- approve not manual requests -->
        <!-- <v-btn
          class="mx-1"
          small
          outlined
          color="green"
          @click="update(actionType)"
          :disabled="!isFilled"
          v-if="
            form.status == 'pending_approval' &&
            $can('hrms') &&
            !form.is_manual &&
            type == 'hrms'
          "
        >
          approve
        </v-btn> -->

        <!-- approve manual requests -->
        <!-- <v-btn
          small
          outlined
          color="green"
          @click="openReasonModal('approve')"
          class="mx-1"
          v-if="
            form.id &&
            form.status == 'pending_approval' &&
            form.is_manual &&
            $can('hrms') &&
            type == 'hrms'
          "
        >
          Approve</v-btn
        > -->
        <!-- <v-btn
          small
          outlined
          color="red"
          @click="openReasonModal('reject')"
          class="mx-1"
          v-if="
            form.id && form.status == 'pending_approval' && $can('hrms') && type == 'hrms'
          "
        >
          reject</v-btn
        > -->
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment-timezone'
import TiptapEditor from '../util/NewTiptapEditor.vue'
import CustomModal from '../util/CustomModal.vue'
import NewSelectEng from '../util/new_select/NewSelectEng.vue'
import ApprovalStages from '@/components/approval-components/approvalStages.vue'
import ActivityLog from '../user-activity/ActivityLog.vue'

export default {
  name: 'slip-modal',
  components: { TiptapEditor, CustomModal, NewSelectEng, ApprovalStages, ActivityLog },
  data() {
    return {
      // type: '',
      slip_types: [
        { value: 'in', type: 'IN', label: 'In' },
        { value: 'out', type: 'OUT', label: 'Out' },
      ],
      formValid: false,
      showModal: false,
      reasonModal: false,
      loading: false,
      selectedStaff: null,
      logs: [],
      manualRequest: false,
      dataLoaded: false,
      dateIsPassed: false,

      page: 1,
      limit: 60,
      referenceId: null,

      form: {
        staff_id: '',
        requested_date: null,
        requested_type: null,
        reason: '',
        status: '',
        submitted_at: null,
        from_date: null,
        is_manual: false,
        rejected_reason: '',
        approved_reason: '',
      },
      ruleRequired: [v => !!v || 'ފުރިހަމަ ކުރުމަށް!'],
      showTimePanel: false,
      actionType: '',
      reasonType: '',

      allowIncrement: true,
    }
  },
  watch: {
    form: {
      handler(value) {
        if (value.from_date) {
          let time = new moment()
          const today = time.format('YYYY-MM-DD HH:mm:ss')

          let selectedTime = new moment(value.from_date)
          const selectedDate = selectedTime.format('YYYY-MM-DD HH:mm:ss')

          // const today = moment().tz('Indian/Maldives', false)
          // today.format('YYYY-MM-DD HH:mm:ss')

          if (selectedDate > today) {
            // if (selectedDate.isAfter(today)) {
            this.dateIsPassed = true
          } else {
            this.dateIsPassed = false
          }
        }
      },
      deep: true,
    },
  },
  computed: {
    isFilled() {
      return (
        // this.formValid &&
        (this.form.requested_date || this.manualRequest) &&
        this.form.requested_type &&
        this.form.reason &&
        this.form.staff_id &&
        this.form.machine_id &&
        this.form.reason.length > 7
      )
    },

    isEditable() {
      return ['draft'].includes(this.form.status) || !this.form.id
    },

    type() {
      return this.$route.meta.type
    },
  },
  methods: {
    addDay() {
      // let fromDate = new Date(this.form.from_date)
      // console.log(fromDate.getDate())
      // fromDate.setDate(fromDate.getDate() + 1)
      // this.form.from_date = fromDate.toISOString().split('T')[0]
      // console.log(this.form.from_date)
      let fromDate = moment(this.form.from_date)
      fromDate.add(1, 'days')
      this.form.from_date = fromDate.format('YYYY-MM-DD HH:mm:ss')

      this.allowIncrement = false
    },
    open(date, time) {
      this.getUserLogs()
      this.form.staff = this.User.staff
      this.form.staff_id = this.User.staff_id
      this.form.from_date = date
      // this.form.from_date = date + ' ' + time

      this.getAttendance(date)
      this.showModal = true
    },

    openReasonModal(type) {
      this.reasonType = type
      this.reasonModal = !this.reasonModal
    },

    closeReject() {
      this.reasonModal = false
    },

    edit(id, date, type) {
      this.actionType = type

      let selectedTime = moment(date).format('YYYY-MM-DD')

      this.referenceId = id
      this.getUserLogs()
      this.getItem()
      setTimeout(() => {
        this.getAttendance(selectedTime)
      }, 200)

      this.showModal = true
    },

    submit() {
      swal({
        title: 'Are you sure?',
        text: 'Once submitted, you will not be able to amend this request!',
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then(value => {
        if (value) {
          this.loading = true
          this.form.status = 'submitted'
          let time = new moment()
          this.form.submitted_at = time.format('YYYY-MM-DD HH:mm:ss')
          this.$axios
            .put(`/api/attendance-slips/update/${this.form.id}`, this.form)
            .then(resp => {
              this.form = resp.data
              this.loading = false
              this.getItem()
            })
            .finally(() => (this.loading = false))
        }
      })
    },

    close() {
      this.$emit('reload')
      this.resetData()
    },

    resetData() {
      Object.assign(this.$data, this.$options.data())
    },

    clearData() {
      this.form.requested_date = null
    },

    update(type) {
      const today = moment()
      this.form.is_manual = this.manualRequest

      if (this.$can('hrms') && type == 'approve') {
        this.form.status = 'approved'
        this.form.approved_by = this.User.username
        this.form.approved_at = today.format('YYYY-MM-DD HH:mm:ss')
      }
      if (this.$can('hrms') && type == 'reject') {
        this.form.status = 'rejected'
        this.form.rejected_by = this.User.username
        this.form.rejected_at = today.format('YYYY-MM-DD HH:mm:ss')
      }

      if (type == 'edit') {
        this.form.is_manual = this.manualRequest
      }

      this.loading = true
      this.$axios
        .put(`/api/attendance-slips/update/${this.form.id}`, this.form)
        .then(resp => {
          this.form = resp.data
          this.loading = false
          if (this.reasonModal == true) this.reasonModal = false
          this.getItem()
        })
      // .finally(() => {
      //   this.getItem()
      // })
    },

    save() {
      this.form.is_manual = this.manualRequest
      if (this.manualRequest) {
        this.form.requested_date = this.form.from_date
      }
      this.loading = true
      this.$axios.post(`/api/attendance-slips/save`, this.form).then(resp => {
        this.form = resp.data
        console.log(resp.data.data.id)
        this.loading = false
        this.referenceId = resp.data.data.id
        this.getItem()
      })
    },

    getItem() {
      this.loading = true
      this.$axios.get(`/api/attendance_slips/${this.referenceId}`).then(resp => {
        this.form = resp.data
        this.form.staff_id = parseInt(this.form.staff_id)
        this.manualRequest = this.form.is_manual

        if (this.actionType == 'approve') {
          this.formValid = true
        }
      })
      this.loading = false
    },

    getLogs(date) {
      this.loading = true
      var url = `/api/card-logs/getCardLogs?date=${date}&page=${this.page}&limit=${this.limit}`
      if (this.form.staff) url += `&staff=${this.form.staff.EMPNO}`

      this.$axios
        .get(url)
        .then(res => {
          this.logs = res.data.data
          // this.logs = []
          // this.pages = res.data.last_page
          this.loading = false
        })
        .then(
          this.logs.forEach(log => {
            log.door_name = log.door_name.replaceAll('_', ' ')
          })
        )
        .catch(() => {})
    },

    getUserLogs() {
      return this.$axios.get('/api/attendance/in-out-logs/staff').then(resp => {
        this.attendanceLogs = resp.data
        this.dataLoaded = true
      })
    },

    getAttendance(date) {
      this.getLogs(date)
    },

    toggleTimePanel() {
      this.showTimePanel = !this.showTimePanel
    },

    setSelection() {
      // this.form.status = status
      // this.form.requested_date = date
      // console.log(status, date);
    },
  },

  // mounted() {
  //   this.type = this.$route.meta.type
  // },
}
</script>
